var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBestsellers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 60 60",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#314e55",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(6 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.7053257 0h24.5893634l2.3290131 28.1307364c.2226472 2.68922-1.7179687 5.3977745-4.3308201 6.048812l-10.2928748 2.5646494-10.2928746-2.5646494c-2.6144931-.6514466-4.5536378-3.3575326-4.3308201-6.048812z",
    fill: "#dbcf56",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 36v3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 40h14l2 6h-18z",
    fill: "#dbcf56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 44h30v9h-30z",
    fill: "#e4ad40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.9525134 7.27680803 3.4120346-3.27680803h9.5657401s1.0943947 13.3977701-11.4799829 21.6755503"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.27680803 3.41203468-3.27680803h9.56574002s1.0943948 13.3977701-11.47998285 21.6755503",
    transform: "matrix(-1 0 0 1 13.00183 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 20-2.351141 1.236068.449028-2.618034-1.9021131-1.854102 2.6286556-.381966 1.1755705-2.381966 1.1755705 2.381966 2.6286556.381966-1.9021131 1.854102.449028 2.618034z",
    fill: "#d8d8d8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestsellers);
export default __webpack_public_path__ + "static/media/bestsellers.8c472281f18049510618e655a5ae6f10.svg";
export { ForwardRef as ReactComponent };